import { normalizeApiError } from './apiEnvelope'

/** Anexos em base64 (até 30 MB cada) não cabem no timeout padrão do httpClient em rede móvel. */
export const UPLOAD_TIMEOUT_MS = 120_000

/** Falha sem resposta num envio com arquivo: rede, timeout ou o servidor barrando o tamanho (chega como "CORS"). */
export const UPLOAD_NETWORK_ERROR_MESSAGE =
  'Não foi possível enviar o arquivo. Verifique sua conexão ou tente um arquivo menor.'

/** Mensagem de erro de um envio com arquivo: a falha de rede vira a sugestão de arquivo menor. */
export function mensagemErroUpload(error: unknown): string {
  const normalized = normalizeApiError(error)
  return normalized.isNetworkError ? UPLOAD_NETWORK_ERROR_MESSAGE : normalized.detail
}
